(()=>{'use strict';
const paths=['Polished_Silver_Heart-Shaped_Pendant.png','AUVYR_Monkey_Flow_01_Main.png','AUVYR_Ox_Flow_01_Front.png','AUVYR_Dragon_Flow_01_Main.png'];
const dog='AUVYR_Dog_Main_Proportion_Normalized_F9F9F9_2048';
let target=.66;const cache=new Map(),applied=new WeakMap();
const url=i=>i.currentSrc||i.src||'';
function measure(src){
 if(cache.has(src))return cache.get(src);
 const prom=new Promise(resolve=>{
 const ref=new Image();ref.crossOrigin='anonymous';ref.onload=()=>{
 try{
 const w=160,c=document.createElement('canvas');c.width=c.height=w;const ctx=c.getContext('2d',{willReadFrequently:true});ctx.drawImage(ref,0,0,w,w);const p=ctx.getImageData(0,0,w,w).data;
 const rows=new Uint16Array(w),cols=new Uint16Array(w);
 for(let y=0;y<w;y++)for(let x=0;x<w;x++){let i=(y*w+x)*4,r=p[i],g=p[i+1],b=p[i+2],lum=(3*r+5*g+2*b)/10;if(lum<207&&Math.abs(r-249)+Math.abs(g-249)+Math.abs(b-249)>85){rows[y]++;cols[x]++;}}
 let minx=w,miny=w,maxx=0,maxy=0;
 for(let y=0;y<w;y++)if(rows[y]>=3){miny=Math.min(miny,y);maxy=Math.max(maxy,y)}
 for(let x=0;x<w;x++)if(cols[x]>=3){minx=Math.min(minx,x);maxx=Math.max(maxx,x)}
 const h=(maxy-miny)/w;resolve((h<.15||h>.92||minx>=maxx)?null:{h,cx:(minx+maxx)/(2*w),cy:(miny+maxy)/(2*w)});
 }catch(e){resolve(null)}};
 ref.onerror=()=>resolve(null);ref.src=src;});
 cache.set(src,prom);return prom;
}
function isMain(i){let s=url(i);if(!paths.some(p=>s.includes(p)))return false;
 if(i.closest('dialog,.lightbox,.as-gallery__thumbnails,.thumbnail,.thumb,[data-media-thumbnail]'))return false;
 let r=i.getBoundingClientRect();return r.width>=180&&r.height>=145;}
async function fit(i){let s=url(i),key=s+'|'+target.toFixed(3);if(!isMain(i)||applied.get(i)===key)return;applied.set(i,key);
 const b=await measure(s);if(!i.isConnected||!isMain(i))return;
 let zoom,dx=0,dy=0;if(b){zoom=Math.max(.78,Math.min(1.34,target/b.h));dx=Math.max(-9,Math.min(9,(.5-b.cx)*zoom*100));dy=Math.max(-12,Math.min(12,(.5-b.cy)*zoom*100));}
 else{zoom=s.includes(paths[2])?1.17:s.includes(paths[3])?1.09:1.08;}
 i.style.transformOrigin='50% 50%';i.style.transform='translate('+dx.toFixed(2)+'%,'+dy.toFixed(2)+'%) scale('+zoom.toFixed(3)+')';i.style.objectFit='contain';
 if(i.parentElement){i.parentElement.style.backgroundColor='#F9F9F9';i.parentElement.style.overflow='hidden';}
}
let scheduled=false;function scan(){scheduled=false;const imgs=Array.from(document.images);
 const reference=imgs.find(i=>url(i).includes(dog));
 if(reference&&!scan.reference){scan.reference=true;measure(url(reference)).then(b=>{if(b){target=Math.max(.60,Math.min(.75,b.h*1.18));schedule();}});}
 imgs.forEach(i=>{if(isMain(i))fit(i)})}
function schedule(){if(scheduled)return;scheduled=true;requestAnimationFrame(scan)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',schedule,{once:true});else schedule();
window.addEventListener('load',schedule,{once:true});
new MutationObserver(schedule).observe(document.documentElement,{childList:true,subtree:true});
document.addEventListener('shopify:section:load',schedule);
})();